import { PERMISSIONS, AUTHORITIES, PATH_ROUTES } from '../../Constant';

export type TMenu = {
	title: string;
	to: string;
	permission: string;
	ability: string;
	subMenu: TSubMenu[];
	icon: string;
	[key: string]: any;
};

export type TSubMenu = {
  title: string,
  to: string,
  hasBullet?: boolean,
  icon: string
  permission: string,
  ability: string,
  subMenu?: TSubMenu[]
}

type GroupedMenu = {
	title: string;
	separator?: boolean;
	[key: string]: any;
};

type Menu = TMenu | TSubMenu | GroupedMenu;

const MENU_ICON_BASE_PATH = '/media/icons/menu';

export const allMenu: Menu[] = [
	{
		title: 'GENERAL.SYSTEM',
		to: PATH_ROUTES.SYSTEM.DEFAULT,
		permission: PERMISSIONS.ADMIN,
		ability: AUTHORITIES.AUTHORITY.VIEW,
		icon: '/media/icons/homepage/system.svg',
		subMenu: [
			{
				title: 'MENU.ACCOUNT',
				separator: true,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.USER.VIEW,
			},
			{
				title: 'MENU.ACCOUNT',
				to: PATH_ROUTES.SYSTEM.USER,
				icon: `${MENU_ICON_BASE_PATH}/account.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.USER.VIEW,
			},
			{
				title: 'MENU.ROLE',
				to: PATH_ROUTES.SYSTEM.ROLE,
				icon: `${MENU_ICON_BASE_PATH}/role.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.ROLE.VIEW,
			},
			{
				title: 'MENU.AUTH',
				to: PATH_ROUTES.SYSTEM.AUTHORITY,
				icon: `${MENU_ICON_BASE_PATH}/permission.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.AUTHORITY.VIEW,
			},
			{
				title: 'MENU.PERSON_INFO',
				to: PATH_ROUTES.SYSTEM.PERSON,
				icon: `${MENU_ICON_BASE_PATH}/person.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.PERSON.VIEW,
			},
			{
				title: 'MENU.ORGANIZATION',
				separator: true,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.ORGANIZATION.VIEW,
			},
			{
				title: 'MENU.ORGANIZATION',
				to: PATH_ROUTES.SYSTEM.ORGANIZATION,
				icon: `${MENU_ICON_BASE_PATH}/organization.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.ORGANIZATION.VIEW,
			},
			{
				title: 'MENU.FACULTY',
				to: PATH_ROUTES.SYSTEM.FACULTY,
				icon: `${MENU_ICON_BASE_PATH}/department.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.FACULTY.VIEW,
			},
			{
				title: 'MENU.DEPARTMENT',
				to: PATH_ROUTES.SYSTEM.DEPARTMENT,
				icon: `${MENU_ICON_BASE_PATH}/department.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.DEPARTMENT.VIEW,
			},
			{
				title: 'MENU.CHAMBER',
				to: PATH_ROUTES.SYSTEM.CHAMBER,
				icon: `${MENU_ICON_BASE_PATH}/chamber.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.CHAMBER.VIEW,
			},
			{
				title: 'MENU.BED',
				to: PATH_ROUTES.SYSTEM.BED,
				icon: `${MENU_ICON_BASE_PATH}/bed.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.CHAMBER.VIEW,
			},
			{
				title: 'CATEGORY',
				separator: true,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.PERSON.VIEW,
			},
			{
				title: 'MENU.TECHNICAL_SERVICE',
				to: PATH_ROUTES.SYSTEM.SERVICE,
				icon: `${MENU_ICON_BASE_PATH}/service.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.PERSON.VIEW,
			},
			{
				title: 'MENU.EXAMINATION_PACKAGE',
				to: PATH_ROUTES.SYSTEM.PACKAGE,
				icon: `${MENU_ICON_BASE_PATH}/package.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.PERSON.VIEW,
			},
			{
				title: 'MENU.CATEGORY',
				to: PATH_ROUTES.SYSTEM.CATEGORY,
				icon: `${MENU_ICON_BASE_PATH}/category.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.CATEGORY.VIEW,
			},
			{
				title: 'OTHER',
				separator: true,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.PERSON.VIEW,
			},
			{
				title: 'MENU.TERM_MODEL',
				to: PATH_ROUTES.SYSTEM.TERM_MODEL,
				icon: `${MENU_ICON_BASE_PATH}/term-model.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.TERM_MODEL.VIEW,
			},
			{
				title: 'MENU.CONFIGURATION',
				to: PATH_ROUTES.SYSTEM.CONFIGURATION,
				icon: `${MENU_ICON_BASE_PATH}/system.svg`,
				permission: PERMISSIONS.ADMIN,
				ability: AUTHORITIES.CONFIGURATION.VIEW,
			},
		],
	},
];
